import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const LatestNewsImageLink = styled(Link)`
    display: block;
    text-decoration: none;
`

export const LatestNewsImage = styled.img`
    width: 100%;

    @media screen and (max-width: 767px) {
        width: 189px !important;
        height: 118px !important;
    }

    @media screen and (max-width: 475px) {
        width: ${({smrow}) => smrow ? '165px !important':'100% !important'};
        height: 105px !important;
    }
`

export const LatestNewsBody = styled.div`
`

export const LatestNewsTitle = styled(Link)`
    text-decoration: none;
    color: #222;
    font-weight: bold;
    line-height: 18px;
    margin-bottom: 3px;
`

export const LatestNewsDesc = styled.p`
    color: #222;
    font-size: 12px;
    line-height: 14px;
    opacity: .7;
    margin-top: 5px;
`


export const LatestNewsItem = styled.li`
    display: flex;
    flex-direction: ${({type}) => type === 'big'?'column':'row'};
    padding: 10px 0 11px;
    border-bottom: dotted 1px #bdbdbd;

    & ${LatestNewsTitle} {
        font-size: ${({type}) => type === 'big'?'18px':'15px'};
        height: ${({type}) => type === 'big'?'36px':'unset'};
        -webkit-line-clamp: ${({type}) => type === 'big'?'2':'3'};
        -webkit-box-orient: vertical;
        overflow: hidden;
        display: -webkit-box;
    }

    & ${LatestNewsImage} {
        height: ${({type}) => type === 'big'?'293px':'132px'};
    }

    & ${LatestNewsDesc} {
        -webkit-line-clamp: ${({type}) => type === 'big'?'2':'3'};
        -webkit-box-orient: vertical;
        overflow: hidden;
        display: -webkit-box;
    }

    & ${LatestNewsBody} {
        order: ${({type}) => type === 'big'?'0':'1'};
        margin-left: ${({type}) => type === 'big'?'0':'10px'};
        margin-bottom: ${({type}) => type === 'big'?'15px':'0'};

    }

    & ${LatestNewsImageLink} {
        width: ${({type}) => type === 'big'?'100%':'212px'};
        order: ${({type}) => type === 'big'?'1':'0'};
    }

    & ${LatestNewsImage} {
        width: ${({type}) => type === 'big'?'100%':'212px'};
    }

    @media screen and (max-width: 767px) {
        flex-direction: ${({smrow}) => smrow ? 'row':'column'};
        border-bottom: ${({smrow}) => smrow ? 'dotted 1px #bdbdbd':'none'};

        ${LatestNewsImageLink} {
            width: unset;
        }

        ${LatestNewsTitle} {
            font-size: 17px;
            align-self: flex-start;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            display: -webkit-box;
            color: #333;
            line-height: 20px;
            height: 60px;
        }

        ${LatestNewsBody} {
            margin-left: ${({smrow}) => smrow?'10px':'0'};
            margin-top: 3px;
        }
    }

    @media screen and (max-width: 475px) {
        ${LatestNewsImage} {
            width: ${({smrow}) => smrow && '128px !important'};
            height: ${({smrow}) => smrow && '80px !important'};
        }

        ${LatestNewsTitle} {
            line-height: 20px;
            font-size: ${({smrow}) => smrow && '16px !important'};
            -webkit-line-clamp: ${({fixedheight}) => fixedheight ? '3 !important':'4 !important'};
            height: ${({fixedheight}) => fixedheight ? '60px !important':'auto !important'};
        }
    }
 `


export const CreatedDate = styled.span`
    color: #222;
    font-size: 12px;
    line-height: 14px;
    opacity: .7;
    margin-top: 8px;
    display: inline-block;
`